export default function AboutLink() {
    return (
        <a href="http://bl.ockss.org/" style={{ color: 'rgb(70, 130, 180)', textDecoration: 'none' }}>
            bl.ockss.org
        </a>
    );
}